// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ce1T","largestCol":"styles_largestCol__1-bFq","smallestCol":"styles_smallestCol__1pD_M"};